import React, { useState } from 'react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { BrowserCompatWrapper } from '@/components/ui/BrowserCompatWrapper';
import {
  LinkOfficialAccommodationDialog,
  type LinkStatusTarget,
} from './LinkOfficialAccommodationDialog';
import { PreRegistrationStatusMenu } from './PreRegistrationStatusMenu';
import type {
  MunicipalListAccommodation,
  PreRegistrationStatusCode,
} from '../types/pre-registration.types';

// Transitions that need the official accommodation, by current status
const LINK_ACTIONS: Partial<Record<PreRegistrationStatusCode, { target: LinkStatusTarget; label: string }>> = {
  pending_review: { target: 'already_registered', label: 'Marcar como Ya registrado…' },
  to_regularize: { target: 'regularized', label: 'Marcar como Regularizado…' },
};

interface PreRegistrationRowActionsProps {
  row: MunicipalListAccommodation;
  departmentId?: number;
}

// Status menu of a row plus the link entries; the dialog lives outside the menu so it survives
// the menu closing
export const PreRegistrationRowActions: React.FC<PreRegistrationRowActionsProps> = ({
  row,
  departmentId,
}) => {
  const [linkOpen, setLinkOpen] = useState(false);
  const linkAction = LINK_ACTIONS[row.status.code];

  return (
    <BrowserCompatWrapper>
      <PreRegistrationStatusMenu row={row}>
        {linkAction && (
          <DropdownMenuItem onSelect={() => setLinkOpen(true)}>{linkAction.label}</DropdownMenuItem>
        )}
      </PreRegistrationStatusMenu>
      {linkAction && (
        <LinkOfficialAccommodationDialog
          open={linkOpen}
          onOpenChange={setLinkOpen}
          row={row}
          target={linkAction.target}
          departmentId={departmentId}
        />
      )}
    </BrowserCompatWrapper>
  );
};
